(() => {
  const init = (root) => {
    if (root.dataset.storiesReady) return;
    root.dataset.storiesReady = 'true';
    const reel = root.querySelector('[data-spc-reel]');
    if (!reel) return;
    const items = [...reel.querySelectorAll('.spc__reel-item')].map(el => el.dataset);
    if (!items.length) return;
    /* 14.10.2026 (Beschwerden-Seiten, Nayl: ein Testimonial-Video, kein Scroll-Effekt): mit genau einer Story
       kein Weiterschalten, kein Wischen, keine Pfeiltasten; der Clip laeuft stumm und mit Ton als Schleife. */
    const single = items.length <= 1;
    const q = selector => reel.querySelector(selector);
    const videos = [...reel.querySelectorAll('video')];
    const reduced = matchMedia('(prefers-reduced-motion: reduce)');
    const play = q('[data-reel-play]');
    const mute = q('[data-reel-mute]');
    const status = q('[data-reel-status]');
    /* Playback nach Best Practice (SF-PDP-02, 25.09.2026):
       - Nichts lädt vorab: preload="none", kein poster-Attribut (das eine Vorschaubild dahinter lädt lazy).
       - Kurz bevor die Section ins Bild kommt, holt nur das aktive Video Metadaten + erstes Bild.
       - Abgespielt wird nur, solange mindestens 20 % sichtbar sind und der Tab offen ist.
       - Ein verlassenes Video bricht seinen Download ab (Quellen ab, load()); die Quellen stehen im
         HTML, bis ein Video einmal aktiv war (Googlebot sieht alle).
       - Datensparmodus/2G und "Bewegung reduzieren": kein Autoplay, kein Weiterschalten. */
    const conn = navigator.connection;
    const lowData = !!(conn && (conn.saveData || /(^|-)2g$/.test(conn.effectiveType || '')));
    const advance = Math.max(0, Number(root.dataset.advance || 0));
    let index = 0, visible = false, inFocus = false, hovering = false, paused = reduced.matches || lowData, muted = true;
    /* Automatisch weiter (Nayl 25.09.2026: "kleiner Auto-Scroll-Effekt, wenn es im View ist, dass es
       dann ein Video weiter geht"): stumm läuft jeder Clip `advance` Sekunden, dann gleitet die nächste
       Story rein; der aktive Punkt füllt sich als Fortschritt. Nur wenn mind. 50 % im Bild, nicht unter
       der Maus. Wer selbst blättert, wischt oder per Tastatur hineinfokussiert, stoppt das Weiterschalten
       (WAI-ARIA-Karussell). Mit Ton läuft der Clip ganz und schaltet am Ende weiter (Story-Verhalten). */
    let auto = advance > 0 && !reduced.matches && !lowData && !single;
    const dots = q('[data-reel-dots]');
    const transcripts = root.querySelector('[data-spc-transcripts]');
    root.classList.add('spc--js');
    /* Wer das Transkript aufklappt, liest: Weiterschalten stoppt (sonst wechselt der Text unter der Hand) */
    if (transcripts) transcripts.addEventListener('toggle', () => { if (transcripts.open) stopAuto(); });
    const hasMeta = items.some(it => it.ago || it.views);
    const activeVideo = () => items[index].videoId ? document.getElementById(items[index].videoId) : null;
    const syncButtons = () => {
      const video = activeVideo();
      const playing = video && !video.paused;
      play.textContent = playing ? 'Pause' : 'Abspielen';
      play.setAttribute('aria-label', playing ? 'Video pausieren' : 'Video abspielen');
      play.setAttribute('aria-pressed', String(!!playing));
      mute.setAttribute('aria-label', muted ? 'Ton einschalten' : 'Ton ausschalten');
      mute.setAttribute('aria-pressed', String(!muted));
      mute.classList.toggle('is-unmuted', !muted);
    };
    const setP = p => { [...dots.children].forEach((d, i) => { if (i === index && p < 1) d.style.setProperty('--spc-p', p.toFixed(3)); else d.style.removeProperty('--spc-p'); }); };
    const detach = v => {
      if (!v.dataset.live) { v.pause(); return; }
      v.pause(); v.preload = 'none';
      v.querySelectorAll('source').forEach(src => { if (src.getAttribute('src')) { src.dataset.src = src.getAttribute('src'); src.removeAttribute('src'); } });
      v.load(); delete v.dataset.live;
    };
    const attach = v => {
      if (v.dataset.live) return;
      let restored = false;
      v.querySelectorAll('source').forEach(src => { if (src.dataset.src && !src.getAttribute('src')) { src.setAttribute('src', src.dataset.src); restored = true; } });
      if (restored) v.load();
      v.dataset.live = '1';
    };
    const warm = v => {
      if (!v || lowData || v.preload !== 'none' || !v.paused || v.readyState > 0) return;
      attach(v); v.preload = 'metadata'; v.load();
    };
    const stopAuto = () => {
      if (!auto) return;
      auto = false; setP(1); status.setAttribute('aria-live', 'polite');
    };
    let raf = 0, warmedNext = false;
    const tick = () => {
      raf = 0;
      const v = activeVideo();
      if (!v || v.paused) return;
      const span = !muted ? (v.duration || 0) : (auto ? advance : 0);
      setP(span ? Math.min(1, v.currentTime / span) : 1);
      if (auto && muted) {
        if (!warmedNext && v.currentTime >= advance / 2) { warmedNext = true; const n = items[(index + 1) % items.length]; warm(n.videoId ? document.getElementById(n.videoId) : null); }
        if (inFocus && !hovering && v.currentTime >= advance) { go(index + 1, 1); return; }
      }
      raf = requestAnimationFrame(tick);
    };
    const syncPlayback = () => {
      const active = activeVideo();
      videos.forEach(v => { if (v !== active) v.pause(); });
      if (active) {
        active.muted = muted;
        active.loop = muted || single;
        if (visible && !document.hidden && !paused) active.play().catch(syncButtons);
        else active.pause();
      }
      syncButtons();
    };
    const render = () => {
      const item = items[index];
      [['topic','topic'],['init','init'],['name','name'],['followers','followers'],['ago','ago'],['views','views']].forEach(([selector,key]) => {
        const el=q('[data-reel-'+selector+']'); if (el) el.textContent=item[key] || '';
      });
      [['sport','sport'],['reason','reason'],['quote','benefit'],['name','name'],['initials','init']].forEach(([selector,key]) => {
        const el=root.querySelector('[data-person-'+selector+']:not(.spc__ghost)'); if(el) el.textContent=item[key] || '';
      });
      root.querySelectorAll('[data-person-avatar], [data-reel-avatar]').forEach(img => { img.src = item.avatar || item.img; img.alt = item.name; });
      /* Zeile unter dem Namen im Zitat (Standard "Aus dem Video", je Clip einstellbar; 29.09.2026) */
      const srcLine = root.querySelector('[data-person-source]'); if (srcLine && item.source) srcLine.textContent = item.source;
      /* SVG kennt die Eigenschaft .hidden nicht - das Attribut setzen, sonst bleibt der Haken immer sichtbar */
      root.querySelectorAll('[data-person-verified]').forEach(badge => { badge.toggleAttribute('hidden', item.verified !== 'true'); });
      const sportIcons = {'Bodybuilding':'dumbbell','Krafttraining':'dumbbell','Radsport':'bike','HYROX':'kettlebell','Fitness & Coaching':'activity','Bikini-Fitness':'medal','Erholung im Alltag':'recovery','Alltag & Erholung':'recovery'};
      const reasonIcons = {'Nach dem Beintraining':'clock','Recovery nach dem Sport':'clock','Anwendung zuhause':'home','Auch auf Reisen':'plane','Pause im Gym':'dumbbell','Auszeit auf dem Sofa':'sofa'};
      [['sport',sportIcons[item.sport] || 'activity'],['reason',reasonIcons[item.reason] || 'clock']].forEach(([slot,icon]) => {
        /* 30.09.2026: Tag-Icons aus dem STARKFELD-Icon-Set (Masken-URL aus data-sf-icons), sonst altes Symbol */
        const host=root.querySelector('[data-person-'+slot+'-icon]'); if(!host) return;
        const use=host.querySelector('use'); if(use){ use.setAttribute('href','#'+root.id+'-icon-'+icon); return; }
        let map={}; try{ map=JSON.parse(root.dataset.sfIcons||'{}'); }catch(e){}
        const svg=host.querySelector('svg'); const url=map[icon];
        if(svg && url){ svg.style.webkitMaskImage='url("'+url+'")'; svg.style.maskImage='url("'+url+'")'; }
      });
      /* Feste Maße (Nayl 24.09.2026: nichts springt): Zitat und Meta-Zeile nie aus dem Layout
         nehmen, nur unsichtbar machen - ihr Platz bleibt stehen. Die Meta-Zeile faellt nur weg,
         wenn KEINE Story Datum/Views hat (dann fuer alle gleich). */
      const testimonial = root.querySelector('[data-person-testimonial]');
      if (testimonial) { testimonial.hidden = false; testimonial.classList.toggle('is-empty', !item.benefit); }
      const meta = q('.spc__story-meta');
      if (meta) { meta.hidden = !hasMeta; meta.style.visibility = (item.ago || item.views) ? '' : 'hidden'; }
      const img = q('[data-reel-img]');
      img.src = item.img; img.alt = item.name + ' mit ' + (root.dataset.productName || 'STARKBOOTS');
      [['b0',-1],['b1',1]].forEach(([slot,offset]) => {
        q('[data-reel-'+slot+']').src=items[(index+offset+items.length)%items.length].img;
      });
      const act = activeVideo();
      videos.forEach(v => { if (v !== act) { detach(v); v.style.display = 'none'; } });
      if (act) { attach(act); act.style.display = 'block'; try { act.currentTime = 0; } catch (e) {} }
      warmedNext = false;
      play.hidden = !activeVideo(); mute.hidden = !activeVideo();
      mute.classList.toggle('is-visible', !!activeVideo());
      [...dots.children].forEach((dot,i)=>{
        dot.classList.toggle('is-active',i===index);
        dot.setAttribute('aria-current',String(i===index));
      });
      status.textContent=(index+1)+' von '+items.length+' · '+item.name;
      /* Transkript der laufenden Story (alle stehen im HTML) */
      root.querySelectorAll('[data-spc-tr]').forEach(tr => tr.classList.toggle('is-active', tr.dataset.spcTr === item.reelNo));
      if (transcripts) transcripts.hidden = !root.querySelector('[data-spc-tr].is-active');
      status.setAttribute('aria-live', auto ? 'off' : 'polite');
      setP(auto ? 0 : 1);
      syncPlayback();
    };
    const stageEl = q('.spc__stage');
    /* dir: +1 weiter, -1 zurueck -> kurze Schiebe-Animation der aktiven Story (CSS, reduced-motion aus) */
    const go = (next, dir, user) => {
      if (single) return;
      if (user) stopAuto();
      index=(next+items.length)%items.length;render();
      if (dir && stageEl) { stageEl.classList.remove('is-next','is-prev'); void stageEl.offsetWidth; stageEl.classList.add(dir>0?'is-next':'is-prev'); }
    };
    items.forEach((item,i)=>{
      const dot=document.createElement('button');dot.type='button';dot.className='nav-dot';
      dot.setAttribute('aria-label','Video von '+item.name);dot.addEventListener('click',()=>go(i,Math.sign(i-index),true));dots.append(dot);
    });
    q('[data-reel-prev]').addEventListener('click',()=>go(index-1,-1,true));
    q('[data-reel-next]').addEventListener('click',()=>go(index+1,1,true));
    /* Die Tippfläche liegt über dem ganzen Video (29.09.2026, sichtbare Pause-Pille entfernt): ein Maus-Wisch
       über die Bühne endet mit einem Klick auf den Knopf. Der darf die neue Story nicht gleich pausieren. */
    play.addEventListener('click',()=>{if(Date.now()-swipedAt<400)return;paused=!!activeVideo()&&!activeVideo().paused;syncPlayback();});
    mute.addEventListener('click',()=>{muted=!muted;if(!muted)stopAuto();syncPlayback();});
    reel.addEventListener('keydown',e=>{
      if(e.key==='ArrowLeft'||e.key==='ArrowRight'){e.preventDefault();const d=e.key==='ArrowLeft'?-1:1;go(index+d,d,true);}
    });
    /* Wischen (Touch und Maus) und Durchklicken ueber die Vorschau-Karten links/rechts.
       touch-action: pan-y auf der Buehne (CSS) laesst senkrechtes Scrollen durch; eine
       waagrechte Geste ab 40 px wechselt die Story. Ein Wisch loest keinen Klick aus. */
    const stage=q('.spc__stage');
    let sx=null, sy=null, swipedAt=0;
    stage.addEventListener('pointerdown',e=>{ if(e.pointerType==='mouse'&&e.button!==0) return; sx=e.clientX; sy=e.clientY; },{passive:true});
    stage.addEventListener('pointerup',e=>{
      if(sx===null) return; const dx=e.clientX-sx, dy=e.clientY-sy; sx=null;
      if(Math.abs(dx)>40&&Math.abs(dx)>Math.abs(dy)*1.2){ swipedAt=Date.now(); const d=dx<0?1:-1; go(index+d,d,true); }
    },{passive:true});
    stage.addEventListener('pointercancel',()=>{sx=null;});
    [['.spc__peek--left',-1],['.spc__peek--right',1]].forEach(([sel,d])=>{
      const peek=q(sel); if(!peek) return;
      peek.addEventListener('click',()=>{ if(Date.now()-swipedAt<400) return; go(index+d,d,true); });
    });
    videos.forEach(v=>{
      v.addEventListener('play',syncButtons);v.addEventListener('pause',syncButtons);
      v.addEventListener('playing',()=>{ if(!raf && v===activeVideo()) raf=requestAnimationFrame(tick); });
      /* mit Ton: Clip läuft ganz, am Ende die nächste Story */
      v.addEventListener('ended',()=>{ if(v===activeVideo() && !muted) go(index+1,1); });
      /* nur ein echter Fehler des aktiven Videos (abgehängte Quellen sind kein Fehler) */
      v.addEventListener('error',()=>{ if(v!==activeVideo()||!v.dataset.live) return; v.style.display='none';paused=true;syncButtons(); });
    });
    stage.addEventListener('pointerenter',e=>{ if(e.pointerType==='mouse') hovering=true; });
    stage.addEventListener('pointerleave',()=>{ hovering=false; });
    reel.addEventListener('focusin',e=>{ try { if(e.target.matches(':focus-visible')) stopAuto(); } catch(err) {} });
    const onVisibility=()=>syncPlayback();
    const onMotion=()=>{if(reduced.matches)paused=true;syncPlayback();};
    document.addEventListener('visibilitychange',onVisibility);
    reduced.addEventListener('change',onMotion);
    const observer=new IntersectionObserver(entries=>{
      const r=entries[0].intersectionRatio; visible=entries[0].isIntersecting&&r>=.2; inFocus=r>=.5; syncPlayback();
    },{threshold:[0,.2,.5]});
    observer.observe(reel);
    /* Vorwärmen: kurz vor dem Sichtbereich nur Metadaten + erstes Bild des aktiven Videos */
    /* 25.10.2026 (Ladezeit, Nayl: "Lazy Loading ueberall"): Vorwaermen erst nach der ersten echten Geste
       (Scrollen, Tippen, Taste) und erst 200 px vor dem Sichtbereich. Vorher lud Chrome den HLS-Stream schon
       beim Seitenaufruf in 1080p vor (lp-beschwerden: 3 Segmente, 4,6 MB), sobald die Section im 400-px-Vorlauf
       lag. Abspielen im Sichtbereich (observer oben) bleibt unveraendert. */
    const spcGestures=['scroll','pointerdown','touchstart','keydown'];
    let spcMoved=false, spcNear=false;
    const spcUnlisten=()=>spcGestures.forEach(t=>removeEventListener(t,spcOnMove));
    const spcTryWarm=()=>{ if(spcMoved&&spcNear){ warm(activeVideo()); nearObs.disconnect(); spcUnlisten(); } };
    function spcOnMove(){ spcMoved=true; spcUnlisten(); spcTryWarm(); }
    spcGestures.forEach(t=>addEventListener(t,spcOnMove,{passive:true}));
    const nearObs=new IntersectionObserver(entries=>{ spcNear=entries[0].isIntersecting; spcTryWarm(); },{rootMargin:'200px 0px'});
    nearObs.observe(reel);
    root.addEventListener('shopify:section:unload',()=>{observer.disconnect();nearObs.disconnect();spcUnlisten();videos.forEach(v=>v.pause());document.removeEventListener('visibilitychange',onVisibility);reduced.removeEventListener('change',onMotion);},{once:true});
    /* Einspaltig (< 1024 px, Stil "overlay"; Nayl 24./25.09.2026: "Quote und Tag auf Mobile über
       das Video", Overlay auch auf Tablet und Handy quer): Kacheln und Zitat wandern als Overlay in
       die Video-Karte (.spc__ovl), ab 1024 px zurück an ihren Platz. Stil "stack" lässt sie stehen.
       render() findet sie weiter über root.querySelector, nichts wird doppelt. */
    const ovlFacts = root.querySelector('.spc__facts');
    const ovlQuote = root.querySelector('[data-person-testimonial]');
    const ovlMedia = q('.spc__story-media');
    if (root.dataset.mobileStyle !== 'stack' && ovlFacts && ovlQuote && ovlMedia) {
      const factsHome = document.createComment('spc-facts');
      const quoteHome = document.createComment('spc-quote');
      ovlFacts.before(factsHome);
      ovlQuote.before(quoteHome);
      const ovlTop = document.createElement('div');
      ovlTop.className = 'spc__ovl spc__ovl--top';
      const ovlBottom = document.createElement('div');
      ovlBottom.className = 'spc__ovl spc__ovl--bottom';
      const foot = ovlMedia.querySelector('.spc__story-foot');
      ovlMedia.insertBefore(ovlTop, foot);
      ovlMedia.insertBefore(ovlBottom, foot);
      const mobile = matchMedia('(max-width: 1023.98px)');
      const place = () => {
        if (mobile.matches) { ovlTop.append(ovlFacts); ovlBottom.append(ovlQuote); }
        else { factsHome.after(ovlFacts); quoteHome.after(ovlQuote); }
      };
      place();
      mobile.addEventListener('change', place);
    }
    render();
  };
  /* Kaufbutton: Zeigt der Link auf eine Sprungmarke, die es nicht gibt (Section-ID eines anderen
     Templates), geht es zum Kaufbereich main-product wie beim Hero (assets/sf-hero.js). */
  document.addEventListener('click', e => {
    const a = e.target.closest && e.target.closest('[data-sf-boots-stories] [data-spc-buy]');
    if (!a) return;
    const href = a.getAttribute('href') || '';
    if (href.charAt(0) !== '#' || href.length < 2 || document.getElementById(href.slice(1))) return;
    const form = document.querySelector('form[action*="/cart/add"]');
    const target = document.querySelector('[data-sf-main-product]') || (form && (form.closest('.shopify-section') || form));
    if (!target) return;
    e.preventDefault();
    target.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
  });
  document.querySelectorAll('[data-sf-boots-stories]').forEach(init);
  document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('[data-sf-boots-stories]').forEach(init));
})();
